import { CallSplit } from "@mui/icons-material";
import React, { memo } from "react";

import { NodeCard, NodeHandle, useNodeStyles } from "./nodeKit";

export default memo(({ data, isConnectable, id }) => {
  const classes = useNodeStyles();

  return (
    <NodeCard color="#0e9fbf" icon={<CallSplit />} title="Randomizador" id={id}>
      <NodeHandle type="target" isConnectable={isConnectable} />
      <div className={classes.outRow} style={{ marginTop: 0 }}>
        <span>{`${data.percent}%`}</span>
        <NodeHandle type="source" id="a" top="50%" offset={-21} isConnectable={isConnectable} />
      </div>
      <div className={classes.outRow}>
        <span>{`${100 - data.percent}%`}</span>
        <NodeHandle type="source" id="b" top="50%" offset={-21} isConnectable={isConnectable} />
      </div>
    </NodeCard>
  );
});
